import React, { ChangeEvent, useEffect, useLayoutEffect, useState } from 'react';
import styles from './Filters.module.scss';
import Search from '/public/svgs/search.svg';
import { Category } from 'generated-graphql';
import { SelectedCategoriesType } from '@/pages/work';

interface FiltersProps {
  categories: Category[],
  search?: string,
  onSearch?: (event: ChangeEvent<HTMLInputElement>) => void,
  filters: SelectedCategoriesType,
  onFilter: (category: string, option?: string, id?: string) => void,
  isWork?: boolean;

}

const Filters: React.FC<FiltersProps> = ({ categories, search, onSearch, filters, onFilter, isWork }) => {

  const [isDesktop, setIsDesktop] = useState<boolean>(true);

  useEffect(() => {
    const isScreenDesktop = (minWidth: number) => {
      return window.innerWidth > minWidth;
    };

    if (document) {

      setIsDesktop(isScreenDesktop(1200));
    }
  }, []);

  const initialState = {
    ...Object.fromEntries(categories.map((obj) => [obj.name, isDesktop])),
  };

  const [expandedStates, setExpandedStates] = useState(initialState);

  useEffect(() => {
    const newState = {
      ...Object.fromEntries(categories.map((obj) => [obj.name, isDesktop])),
    };
    setExpandedStates(newState);
  }, [isDesktop]);

  const isMultiFilter = !!filters.length;

  return (
    <div className={`col-md-3 ${styles.filters}`}>
      {onSearch &&
        <div className={styles.search}>
          <input
            value={search}
            placeholder="Search"
            className="w-100"
            onChange={(e) => onSearch(e)}
          />
          <Search />
        </div>
      }
      {categories.map((c, idx) =>
        c.children?.nodes.length ? (
          <React.Fragment key={idx + "filter"}>
            <div
              className={`${styles.options} ${c.name && expandedStates[c.name] ? styles.openedOptions : ''}`}
              key={c.id}
              style={{ zIndex: idx }}
            >
              <div
                className={styles.filter}
                style={isMultiFilter ? {} : { cursor: 'default' }}
                onClick={() => {
                  if (isMultiFilter) {
                    setExpandedStates((prevState: any) => ({
                      ...prevState,
                      [c.name as string]: !prevState[c.name as string],
                    }))
                  }
                }
                }
              >
                <strong> {c.name}</strong>
                {isMultiFilter && <span className={styles.arrow}>&#8963;</span>}
              </div>
              {c.children?.nodes.length ? (
                <ul>
                  {/* <li
                    style={{ cursor: 'pointer' }}
                    className={`${c.slug &&
                      !filters[c.slug]?.value &&
                      styles.selectedItem
                      }`}
                    onClick={() => onFilter(c.slug || '')}
                  >
                    View All
                  </li> */}
                  {c.children?.nodes.map((subc: Category) => {
                    if (isWork && subc.slug === 'agent3-group') {
                      return;
                    }
                    return (
                      <li
                        style={{ cursor: 'pointer' }}
                        className={`${c.slug &&
                          filters[c.slug]?.value === subc.id &&
                          styles.selectedItem
                          }`}
                        onClick={() =>
                          onFilter(c.slug || '', subc.name || '', subc.id)
                        }
                        key={subc.id}
                      >
                        {subc.name}
                      </li>
                    )
                  })}
                </ul>
              ) : null}
            </div></React.Fragment>
        ) : null,
      )}
    </div>
  )

}
export default Filters;